import { createAction, handleActions } from 'redux-actions';

import { Plan } from '@api/types';

export interface ChangePricingPlan {
  isShown: boolean;
  isLoading: boolean;
  areTermsAccepted: boolean;
  areTermsShown: boolean;
  isContacted: boolean;
  isErrorOccurred: boolean;
  plan?: Plan;
  // TODO: ADAPP-2032 Temporary solution to avoid huge changes. Should be removed.
  isPricingPlanConfirmed: boolean;
}

export const initialState: ChangePricingPlan = {
  isShown: false,
  isLoading: false,
  areTermsAccepted: false,
  areTermsShown: false,
  isContacted: false,
  isErrorOccurred: false,
  isPricingPlanConfirmed: false,
};

// Selectors

export const getState = (state): ChangePricingPlan => state.pricingPlan.changePricingPlan;

// TODO: ADAPP-2032 Temporary solution to avoid huge changes. Should be removed.
export const isPricingPlanConfirmed = (state): boolean => getState(state).isPricingPlanConfirmed;

// Actions

export const SHOW_FORM = 'account/pricingPlan/changePricing/SHOW_FORM';
export const HIDE_FORM = 'account/pricingPlan/changePricing/HIDE_FORM';

export const TOGGLE_TERMS = 'account/pricingPlan/changePricing/TOGGLE_TERMS';

export const SUBMIT_TO_BE_IN_TOUCH = 'account/pricingPlan/changePricing/SUBMIT_TO_BE_IN_TOUCH';
export const TO_BE_IN_TOUCH_SUCCEED = 'account/pricingPlan/changePricing/TO_BE_IN_TOUCH_SUCCEED';
export const TO_BE_IN_TOUCH_FAILED = 'account/pricingPlan/changePricing/TO_BE_IN_TOUCH_FAILED';

export const CONFIRM = 'account/pricingPlan/changePricing/CONFIRM';
export const CONFIRM_SUCCEED = 'account/pricingPlan/changePricing/CONFIRM_SUCCEED';
export const CONFIRM_FAILED = 'account/pricingPlan/changePricing/CONFIRM_FAILED';

export const SHOW_TERMS = 'account/pricingPlan/changePricing/SHOW_TERMS';

export const SHOW_LOADING_SPINNER = 'account/pricingPlan/changePricing/SHOW_LOADING_SPINNER';
export const HIDE_LOADING_SPINNER = 'account/pricingPlan/changePricing/HIDE_LOADING_SPINNER';

export const RESET_ERROR = 'account/pricingPlan/changePricing/RESET_ERROR';

// Actions creators

export const showForm = createAction(SHOW_FORM);
export const hideForm = createAction(HIDE_FORM);

export const toggleTerms = createAction(TOGGLE_TERMS);

export const submitToBeInTouch = createAction(SUBMIT_TO_BE_IN_TOUCH);
export const toBeInTouchSucceed = createAction(TO_BE_IN_TOUCH_SUCCEED);
export const toBeInTouchFailed = createAction(TO_BE_IN_TOUCH_FAILED);

export const confirm = createAction(CONFIRM);
export const confirmSucceed = createAction(CONFIRM_SUCCEED);
export const confirmFailed = createAction(CONFIRM_FAILED);

export const showTerms = createAction(SHOW_TERMS);

export const showLoadingSpinner = createAction(SHOW_LOADING_SPINNER);
export const hideLoadingSpinner = createAction(HIDE_LOADING_SPINNER);

export const resetError = createAction(RESET_ERROR);

// Reducers

const handleShowForm = (_state: ChangePricingPlan, { payload: plan }): ChangePricingPlan => ({
  ...initialState, // resets the state to default one
  plan,
  isShown: true,
});

const handleHideForm = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isShown: false,
});

const handleToggleTerms = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  areTermsAccepted: !state.areTermsAccepted,
});

const handleToBeInTouchSucceed = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isContacted: true,
});

const handleToBeInTouchFailed = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isContacted: false,
  isErrorOccurred: true,
});

const handleShowTerms = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  areTermsShown: true,
});

const handleShowLoadingSpinner = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isLoading: true,
});

const handleHideLoadingSpinner = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isLoading: false,
});

const handleConfirmFailed = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isErrorOccurred: true,
});

const handleConfirmSucceed = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isShown: false,
  // TODO: ADAPP-2032 Temporary solution to avoid huge changes. Should be removed.
  isPricingPlanConfirmed: true,
});

const handleResetError = (state: ChangePricingPlan): ChangePricingPlan => ({
  ...state,
  isErrorOccurred: false,
});

export default handleActions(
  {
    [SHOW_FORM]: handleShowForm,
    [HIDE_FORM]: handleHideForm,
    [TOGGLE_TERMS]: handleToggleTerms,
    [TO_BE_IN_TOUCH_SUCCEED]: handleToBeInTouchSucceed,
    [TO_BE_IN_TOUCH_FAILED]: handleToBeInTouchFailed,
    [SHOW_TERMS]: handleShowTerms,
    [SHOW_LOADING_SPINNER]: handleShowLoadingSpinner,
    [HIDE_LOADING_SPINNER]: handleHideLoadingSpinner,
    [CONFIRM_FAILED]: handleConfirmFailed,
    [CONFIRM_SUCCEED]: handleConfirmSucceed,
    [RESET_ERROR]: handleResetError,
  },
  initialState,
);
